"use client";

import { c as _c } from "react/compiler-runtime";
import TeaserBarWrapper from "~/components/common/teaserbar-eon/teaserbar-wrapper-eon";
import { TeaserCard } from "~/components/common/teaserbar-eon/teasercard-eon";
import { useLanguage } from "~/translations/loader/use-language";
import AllJobsCtaEonGridsolutions from "./all-jobs-cta-eon-gridsolutions";

/** Registry `TeaserBar` for Grid Solutions: legacy TeaserBar.eon.eongrid content + All Jobs CTA. */
export default function TeaserBarEonGridsolutions() {
  const $ = _c(8);
  const t = useLanguage();
  let t0;
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <TeaserCard href="https://www.eon-gridsolutions.com/de/ueber-uns/eon-grid-solutions.html" imageSrc="images/teaserbar/teaser1_2026.webp" title={"\xDCber uns"} />;
    t1 = <TeaserCard href="https://www.eon-gridsolutions.com/de/karriere-und-jobs/bewerbungsprozess.html" imageSrc="images/teaserbar/teaser2_2026.webp" title="Bewerbungsprozess" />;
    t2 = <TeaserCard href="https://www.eon-gridsolutions.com/de/ueber-uns/team.html" imageSrc="images/teaserbar/teaser3_2026.webp" title="Unser Team" />;
    $[0] = t0;
    $[1] = t1;
    $[2] = t2;
  } else {
    t0 = $[0];
    t1 = $[1];
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t.teaserbar_header) {
    t3 = <TeaserBarWrapper className="font-bold text-4xl text-primary md:text-right lg:text-5xl" headline={t.teaserbar_header}>{t0}{t1}{t2}</TeaserBarWrapper>;
    $[3] = t.teaserbar_header;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <AllJobsCtaEonGridsolutions />;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t3) {
    t5 = <>{t3}{t4}</>;
    $[6] = t3;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  return t5;
}